import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Typography, Stack } from "@mui/material";
import HeightBox from "../HeightBox";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: "11pt",
  fontWeight: 400,
  padding: "10pt 40pt",
}));

export const AddifatNotMarriedPrintOut = React.forwardRef((props, ref) => {
  const { formValues } = props;
  const district = formValues.district;
  const secreteriat = formValues.secreterial;
  const village = formValues.village;
  const addressOne = formValues.address;
  const name = formValues.fullName;
  const religion = formValues.religion;
  const lieceneNumber = formValues.lieceneId;
  const idNumber = formValues.nationalId;

  return (
    <Container ref={ref}>
      <style type="text/css" media="print">
        {"\
   @page { size: portrait; }\
"}
      </style>
      <img
        src="/images/affidat_not_married.jpg"
        alt=""
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: -1,
        }}
      />
      <HeightBox height={250} />
      <CustomTypography>
        ශ්‍රී ලංකා ප්‍රජාතන්ත්‍රවාදී ජනරජයේ  {"   "} <span style={{fontWeight:800}}>{district}</span> {"   "}දිස්ත්‍රික්කයේ<span style={{fontWeight:800}}>{" "}
        {"   "}{secreteriat} {"   "}</span>
        ප්‍රාදේශීය ලේකම් කොට්ඨාසයේ <span style={{fontWeight:800}}> {"   "}{village} {"   "}</span> ග්‍රාමයේ
        <span style={{fontWeight:800}}> {"   "}{addressOne} {"   "}</span> ලිපිනයෙහි පදිංචි<span style={{fontWeight:800}}>
        {"   "}{name} {"   "}</span> වන මම<span style={{fontWeight:800}}> {"   "}{religion} {"   "}</span> බැතිමතියෙක් වශයෙන් අවංකවත් සත්‍ය ලෙසත්
        ගාම්භීරපූර්වකවත් පහත සදහන් පරිදි දිවුරා ප්‍රතිඥා කර සිටිමි.
        <br /> 01.ඉහත නම සදහන් දිවුරුම් ප්‍රකාශයේ දිවුරුම් ප්‍රකාශිකාව මම වෙමි.
        <br /> 02.මාගේ ගමන් බලපත්‍ර අංකය <span style={{fontWeight:800}}> {"   "}{formValues.passport} {"   "}</span>
        වන අතර එය නිකුත් කරන දිනය<span style={{fontWeight:800}}> {"   "}{formValues.passport_issued} {"   "}</span> සහ මාගේ ජාතික හැදුනුම්පත් අංකය<span style={{fontWeight:800}}>{" "}
        {"   "}{idNumber} {"   "}</span> වේ.
        <br /> 03.මා අවිවාහක අතර, මා හට දරුවන් නොමැත.
      </CustomTypography>{" "}
    </Container>
  );
});
